import { TaskType } from '@api';

export const countUnreadTasks = (tasks: TaskType[]): number =>
  tasks.filter((task) => task.status === 'OPEN' && task.isUnread).length;
